import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as CheckIcon } from 'theme/assets/images/check.svg';
import { ReactComponent as LockIcon } from 'theme/assets/images/lock.svg';
import { BonusStatus } from 'constants/appEnums';
import BonusIcon from 'components/BonusIcon';
import RestrictedContainer from 'components/RestrictedContainer';

import './BonusCardDetailsView.scss';

export interface IBonusCardDetailsViewProps {
  titleIcon: string;
  titleText: string;
  bonusState: BonusStatus;
  onActivateClick?: () => void;
}

const BonusCardDetailsView: React.FC<IBonusCardDetailsViewProps> = ({ titleIcon, titleText, bonusState, onActivateClick, children }) => {
  const { t } = useTranslation();

  return (
    <RestrictedContainer className="bonus-card-details">
      <div className="bonus-card-details__container">
        <h1 className="bonus-card-details__title">
          <BonusIcon className="bonus-card-details__title-icon" icon={titleIcon} active={bonusState !== BonusStatus.unavailable} />
          <div className="bonus-card-details__title-text">{titleText}</div>
        </h1>
        {bonusState === BonusStatus.active && (
          <div className="bonus-card-details-activated">
            <CheckIcon height={24} width={24} />
            <div className="bonus-card-details-activated__text">{t('bonus-activated')}</div>
          </div>
        )}
        <div className="bonus-card-details-body">{children}</div>
        {bonusState === BonusStatus.unavailable && (
          <div className="bonus-card-details-locked">
            <LockIcon height={24} width={24} />
            <div className="bonus-card-details-locked__text">{t('bet-£10-within-the-last-7-days-to-qualify-for-this-bonus')}</div>
          </div>
        )}
        {bonusState === BonusStatus.available && (
          <button className="bonus-card-details-button" onClick={onActivateClick}>
            {t('activate-bonus-card')}
          </button>
        )}
      </div>
    </RestrictedContainer>
  );
};

export default BonusCardDetailsView;
